export const accountCategoryFields = [
  {
    name: "categoryName",
    label: "Category Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  //   {
  //     name: "parentAccount",
  //     label: "Parent Account",
  //     type: "text",
  //     gridColumn: "span 2",
  //   },
  //   {
  //     name: "oldParent",
  //     label: "Old Parent",
  //     type: "text",
  //     gridColumn: "span 2",
  //   }
];
export const accountSubcategoryFields = [
  {
    name: "accountName",
    label: "Account Sub-Category Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
];
export const accountFields = [
  {
    name: "accountName",
    label: "Account Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "accountNumber",
    label: "Account Number *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "accountType",
    label: "Account Type *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
   

  {
    name: "currency",
    label: "Currency *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
];
export const paymentTypeFields = [
  {
    name: "paymentType",
    label: "Payment Type *",
    type: "text",
    gridColumn: "span 4",
    required: true,
  },
];
export const bankFields = [
  {
    name: "bankName",
    label: "Bank Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "bankSwiftCode",
    label: "Bank SWIFT Code *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "finCode",
    label: "FIN Code *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "mobile",
    label: "Mobile *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "email",
    label: "Email *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
];

export const bankBranchFields = [
  {
    name: "branchCode",
    label: "Branch Code *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "branchName",
    label: "Branch Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "branchSwiftCode",
    label: "Branch SWIFT Code *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
];
export const bankAccountFields = [
  {
    name: "accountName",
    label: "Account Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "accountNumber",
    label: "Account Number *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "accountDescription",
    label: "Account Description *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
];

export const fiscalYearFields = [
  {
    name: "fiscalYearName",
    label: "Fiscal Year Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "startDate",
    label: "Start Date *",
    type: "date",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "endDate",
    label: "End Date *",
    type: "date",
    gridColumn: "span 2",
    required: true,
  },
];
export const taxAuthorityFields = [
  {
    name: "name",
    label: "Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "jurisdiction",
    label: "Jurisdiction *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
];
export const taxRateFields = [
  {
    name: "name",
    label: "Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "rate",
    label: "Rate *",
    type: "number",
    gridColumn: "span 2",
    required: true,
  },
];
export const subRightsFields = [
  {
    name: "title",
    label: "Title *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
];
export const chargeLineFields = [
  {
    name: "description",
    label: "Description",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "price",
    label: "Price *",
    type: "number",
    gridColumn: "span 2",
    required: true,
  },
];

export const getDebtorsFields = (clientTypes, clients, handleClientTypeChange) => [
  {
    name: "clientTypeId",
    label: "Client Type",
    type: "select",
    options: clientTypes.map((type) => ({
      value: type.id,
      label: type.clientType,
    })),
    gridColumn: "span 2",
    required: true,
    onChangeCustom: handleClientTypeChange, // use this instead of onChange
  },
  {
    name: "clientId",
    label: "Client Name",
    type: "select",
    options: clients,
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "invoiceNumber",
    label: "Invoice Number",
    type: "text",
    gridColumn: "span 1",
    required: true,
  },
  {
    name: "invoiceDate",
    label: "Invoice Date",
    type: "date",
    gridColumn: "span 1",
    required: true,
  },
  {
    name: "dueDate",
    label: "Due Date",
    type: "date",
    gridColumn: "span 1",
    required: true,
  },
  {
    name: "amountBilled",
    label: "Amount Billed",
    type: "number",
    gridColumn: "span 1",
    required: true,
  },
  {
    name: "amountPaid",
    label: "Amount Paid",
    type: "number",
    gridColumn: "span 1",
  },
  {
    name: "balanceDue",
    label: "Balance Due",
    type: "number",
    gridColumn: "span 1",
  },
  {
    name: "currency",
    label: "Currency",
    type: "select",
    options: [
      { value: "KES", label: "KES" },
      { value: "USD", label: "USD" },
      { value: "EUR", label: "EUR" },
    ],
    gridColumn: "span 1",
  },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      { value: "Unpaid", label: "Unpaid" },
      { value: "Partially Paid", label: "Partially Paid" },
      { value: "Paid", label: "Paid" },
      { value: "Overdue", label: "Overdue" },
    ],
    gridColumn: "span 1",
    required: true,
  },
  {
    name: "contactEmail",
    label: "Email",
    type: "email",
    gridColumn: "span 2",
  },
  {
    name: "contactPhone",
    label: "Phone",
    type: "text",
    gridColumn: "span 1",
  },
  {
    name: "remarks",
    label: "Remarks",
    type: "textarea",
    gridColumn: "span 3",
  },
];

export const getFeeNoteFields = (
  clientTypes,
  clients,
  cases,
  currencies,
  documentTypes,
  proformaFeeNotes,
  handleClientTypeChange,
  handleClientChange,
  handleCaseChange
) => [
  {
    name: "issueDate",
    label: "Issue Date",
    type: "date",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "dueDate",
    label: "Due Date",
    type: "date",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "clientTypeId",
    label: "Client Type",
    type: "select",
    options: clientTypes,
    required: true,
    gridColumn: "span 2",
    onChange: (value) => handleClientTypeChange(value),
  },
  {
    name: "clientId",
    label: "Client",
    type: "select",
    options: clients.map((c) => ({ value: c.id, label: c.name })),
    gridColumn: "span 2",
    required: true,
    onChange: (value, values) => handleClientChange(value, values),
  },
  {
    name: "caseId",
    label: "Case",
    type: "select",
    options: cases.map((c) => ({
      value: c.id,
      label: c.title || c.referenceNumber,
    })),
    gridColumn: "span 4",
    required: true,
    onChange: handleCaseChange,
  },
  {
    name: "documentTypeId",
    label: "Document Type",
    type: "select",
    options: documentTypes.map((d) => ({
      value: d.id,
      label: d.documentTypeName,
    })),
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "proformaFeeNoteQuotationId",
    label: "Proforma Fee Note / Quotation",
    type: "select",
    options: proformaFeeNotes.map((p) => ({
      value: p.id,
      label: p.documentNumber || `Proforma #${p.id}`,
    })),
    gridColumn: "span 2",
    required: false,
  },
  {
    name: "amount",
    label: "Amount",
    type: "number",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "currencyId",
    label: "Currency",
    type: "select",
    options: currencies.map((curr) => ({
      value: curr.id,
      label: curr.currencyName || curr.name,
    })),
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "exchangeRate",
    label: "Exchange Rate",
    type: "number",
    gridColumn: "span 2",
  },
  {
    name: "bankAccountId",
    label: "Bank Account ID",
    type: "number",
    gridColumn: "span 2",
  },
];
export const supplierFields = [
  {
    name: "supplierName",
    label: "Supplier Name *",
    type: "text",
    gridColumn: "span 6",
    required: true,
  },
  {
    name: "contactNumber",
    label: "Contact Number",
    type: "text",
    gridColumn: "span 6",
  },
  {
    name: "email",
    label: "Email *",
    type: "email",
    gridColumn: "span 6",
    required: true,
  },
  {
    name: "contactPersonEmail",
    label: "Contact Person Email",
    type: "email",
    gridColumn: "span 6",
  },
  {
    name: "address",
    label: "Address",
    type: "text",
    gridColumn: "span 12",
  },
  {
    name: "registrationNumber",
    label: "Registration Number",
    type: "text",
    gridColumn: "span 6",
  },
  {
    name: "taxIdentificationNumber",
    label: "Tax Identification Number",
    type: "text",
    gridColumn: "span 6",
  },
  {
    name: "contactPersonName",
    label: "Contact Person Name",
    type: "text",
    gridColumn: "span 6",
  },
  {
    name: "contactPersonPhone",
    label: "Contact Person Phone",
    type: "text",
    gridColumn: "span 6",
  },
  {
    name: "industrySector",
    label: "Industry Sector",
    type: "text",
    gridColumn: "span 6",
  },
  {
    name: "statusFlag",
    label: "Status Flag",
    type: "text",
    gridColumn: "span 6",
  },
  {
    name: "notes",
    label: "Notes",
    type: "textarea",
    gridColumn: "span 12",
  },
];